















import CommonBase from "../CommonBase";
import {Component, Inject, Watch} from "vue-property-decorator";
import {NativeApi} from "@/modules/NativeBridge";
import rd from "@/modules/vRoutedefs";

@Component
export default class LoginConfig extends CommonBase {
    @Inject()
    nativeApi!: NativeApi;

    get isApp() {
        return this.nativeApi.available;
    }

    get hostname() {
        return window.location.host;
    }

    choices= [{text: "Standard", value: -1}, {text: "1", value: 1}, {text: "2", value: 2}, {text: "3", value: 3}];

    chosen = 0;

    @Watch("chosen")
    async onChosenChanged() {
        await this.nativeApi.setServerConfiguration(this.chosen);
        this.emitSnack(`login config set to ${this.chosen}. Kill and restart the app`, "success");
    }

    get startTo() {
        return {name: rd.start.name};
    }

}
